<template>
  <div>
    <v-content class="fill-height fill-width my-5">
      <v-container fluid>
        <v-row align="center" justify="center">
          <div v-if="!loading">
            <v-card
              mx-auto
              max-width="600"
              v-for="post in posts"
              :key="post.title"
            >
              <v-img :src="post.thumbnail"></v-img>
              <v-card-title>
                <span class="title font-weight-light">{{ post.title }}</span>
              </v-card-title>
              <v-card-text class="headline font-weight-bold"></v-card-text>
              <div class="bottomText">
                <v-card-actions>
                  <v-list-item class="grow">
                    <v-list-item-avatar color="grey darken-3">
                      <v-img elevation-6 :src="authorImg"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>{{ post.author }}</v-list-item-content>
                  </v-list-item>
                </v-card-actions>
                <v-list-item-content>
                  <v-btn text justify="end" :href="post.link" target="_blank">
                    View Post on Medium
                  </v-btn>
                </v-list-item-content>
              </div>
            </v-card>
          </div>
          <div v-if="loading">
            <v-text-field loading disabled></v-text-field>
          </div>
        </v-row>
      </v-container>
    </v-content>
  </div>
</template>

<script>
export default {
  // TODO: styling
  name: "Index",
  //https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@robinslange
  data: () => ({
    posts: [],
    authorImg: null,
    authorName: null,
    loading: true,
  }),
  mounted() {
    this.$http
      .get(
        "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@robinslange"
      )
      .then((data) => {
        //do stuff
        this.authorImg = data.data.feed.image;
        let items = data.data.items;
        for (let i = 0; i < items.length; i++) {
          this.posts.push(data.data.items[i]);
        }
        setTimeout(() => {
          this.loading = false;
        }, 175);
      });
  },
};
</script>

<style>
.bottomText {
  display: flex;
}
</style>
